import { isBrowser } from "@montana/helpers/browser.helper";

export const requestIdleCallback = isBrowser
    ? window.requestIdleCallback || window.requestAnimationFrame || window.setTimeout
    : setTimeout;
